<template>
	<div>
        <div class="row">
            <el-card class="pb-4 pt-1" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/fuel-retail')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/sales-volume')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">PENCAPAIAN PERTUMBUHAN OUTLET – NON FUEL RETAIL BUSINESS</h4>

                <div class="row px-4">
                    <div class="d-flex align-items-stretch col-md-4 p-0" style="">
                        <div class="p-3" style="width:100%;">
                            <h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">Keagenan LPG</h6>
                            <div class="mb-2">
                                <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                                <img :src="require(`@/assets/img/spbu4.png`)" style="width:100%;border-radius: 10px;">
                            </div>
                           
                        </div>
                    </div>

                    <div class="d-flex align-items-stretch col-md-4 pl-1 pr-1 pt-3" style="">
                        <div class="p-0" style="width:100%;">
                            <h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">BRIGHT</h6>                 
                            <div class="mb-2">
                                <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                                <img :src="require(`@/assets/img/spbu5.png`)" style="width:100%;border-radius: 10px;">
                            </div>
                            
                        </div>
                    </div>

                    <div class="d-flex align-items-stretch col-md-4 p-0 pt-0" style="">
                        <div class="p-3" style="width:100%;">
                            <h6 class="py-1 mb-3" style="background:#2F5597; color:#fff; text-align:center;">SPKLU & SPBKLU</h6>
                            <div class="mb-2">
                                <!--<img v-bind:src="'/media/avatars/' + joke.avatar" /> -->
                                <img :src="require(`@/assets/img/spbu6.png`)" style="width:100%;border-radius: 10px;">
                            </div>
                            
                        </div>
                    </div>
                </div>
            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
// TinyMCE
//import Editor from '@tinymce/tinymce-vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
        //'editor': Editor,
	},

	data() {
		return {
            /*
           tinymce: {
                init: {
                    //height: 500,
                    apiKey: 'j19flohjejcv1yvg1pqafkelpy8in88meplt8o175hdzpimo',
                    menubar: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic underline backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'
                },
                example1 : `<h3 style="color:#FF7711;"><b>KEAGENAN LPG</b></h3>                     
                        <p style="color:#2F5597;"><b>Adanya penambahan keagenan LPG pada pariode Ytd Mei 2023 :</b></p>
                        <ul style="color:#2F5597;">
                            <li><b>Kabupaten Bengkulu Utara</b></li>
                        </ul>
                `,
                example2 : `<h3 style="color:#FF7711;"><b>BRIGHT STORE & CO-BRANDING BRIGHT ALFA</b></h3>
                        <ul style="color:#2F5597;">
                            <li><b>Adanya pergerakan pada posisi Ytd Mei 2023 dengan jumlah bright Alfa yakni 80 Unit (COCO 31 Unit + DODO 49 Unit)</b></li>
                            <li><b>Masih belum adanya penambahan opening Outlet Bright Store baru </b></li>
                            <li><b>Branding Bright Store 1 Unit di SPBU Sudirman Semarang</b></li>
                        </ul>
                `,
                example3 : `<h3 style="color:#FF7711;"><b>SPKLU & SPBKLU</b></h3>
                        <ol style="color:#2F5597;">
                            <li><b>Belum adanya penambahan terkait bisnis SPKLU & SPBKLU.</b></li>
                            <li><b>Pada tahun 2023, akan dilakukan ekspansi penambahan bisnis SPBKLU dan masih dalam tahap penentuan target di SH C&T.</b></li>
                        </ol>
                `,
            }
            */
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
    },
    methods: {

    },
}
</script>